import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

// gtag's own auto-pageview only fires on the initial full page load
// (index.html) — client-side navigation between /insights and
// /insights/admin via React Router wouldn't otherwise register as a
// pageview. Call this once at the top of each routed page component.
export function useAnalyticsPageview() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.gtag?.('config', 'G-ECEJG3VMM5', { page_path: pathname })
  }, [pathname])
}
